module.exports = __webpack_public_path__ + "static/media/right.fb9d36a6.svg";